module.exports = __webpack_public_path__ + "static/img/logo_ld.ea7097a7.png";